import * as THREE from 'three/build/three.module';


class pop_gif
{
    constructor(_o2)
    {
        this.o2=_o2;
        this.gifs=[];
        this.gif_pops=[];
         //表情们
         {
            let promise = _o2.import_object_url('https://o2vr.net/gif/gz2.zip')
            promise.then((obj3) => {
                if (obj3) {
                this.gifs[0] = obj3
                }
            })
        }

        {
            let promise = _o2.import_object_url(
                'https://o2vr.net/gif/zan2.zip'
            )
            promise.then((obj3) => {
                if (obj3) {
                    this.gifs[1] = obj3
                }
            })
        }
        
        {
          let promise = _o2.import_object_url(
              'https://o2vr.net/gif/call.zip'
          )
          promise.then((obj3) => {
              if (obj3) {
                  this.gifs[2] = obj3
              }
          })
      }
      {
            let promise = _o2.import_object_url(
                'https://o2vr.net/gif/heart_ani.zip'
            )
            promise.then((obj3) => {
            if (obj3) {
                this.gifs[3] = obj3
            }
        })
    }
        console.log("pop_gif inited");
        _o2.frame_move_recall.push(this.frame_move);
    }
    frame_move=(timepassed)=>
    {
        
      {
        let now1 = Date.now();
        let new_list = [];
        for (let i = 0; i < this.gif_pops.length; i++) {
          let chat = this.gif_pops[i];
          let dst = now1 - chat.beginTime;
          if (dst > 5000) {
            chat.parent.remove(chat);
          } else {
            new_list.push(chat);
          }
        }
        this.gif_pops = new_list;
      }
    }
    
    gif_pop = (char_obj, idx_gif) =>{
        let sample = this.gifs[idx_gif];
        if (!sample) return;
        let sprite = sample.clone();
        sprite.beginTime = Date.now();
        sprite.position.set(0, 2200, 0);
        char_obj.add(sprite);
        //删除旧的同名角色
        {
            
            for (let i = 0; i < this.gif_pops.length; i++) {
                let chat = this.gif_pops[i];
                if (chat.parent==char_obj)
                {
                    chat.beginTime=chat.beginTime-5000;
                }
            }
        }
        this.gif_pops.push(sprite);
      }
      gif_pop_position = (char_obj,idx_gif,position)=>
      {
        let sample = this.gifs[idx_gif];
        if (!sample) return;
        let sprite = sample.clone();
        sprite.beginTime = Date.now();
        sprite.position.set(position.x,position.y,position.z);
        char_obj.add(sprite);
        //删除旧的同名角色
        {
            
            for (let i = 0; i < this.gif_pops.length; i++) {
                let chat = this.gif_pops[i];
                if (chat.parent==char_obj)
                {
                    chat.beginTime=chat.beginTime-5000;
                }
            }
        }
        this.gif_pops.push(sprite);
        return sprite;
      }
}

class pop_chat
{
    constructor(_o2)
    {
        this.o2=_o2;
        this.chat_pops=[];
        console.log("pop_chat inited");
        _o2.frame_move_recall.push(this.frame_move);
    }
    frame_move=(timepassed)=>
    {
        
      // 处理pops
      {
        let now1 = Date.now();
        let new_list = [];
        for (let i = 0; i < this.chat_pops.length; i++) {
          let chat = this.chat_pops[i];
          let dst = now1 - chat.beginTime;
          if (dst > 10000) {
            chat.parent.remove(chat);
          } else {
            new_list.push(chat);
          }
        }
        this.chat_pops = new_list;
      }
      
    }
    

    chat_pop = (char_obj, text, high = 2200) =>{
      let that=this;
      if (!text.length) return;
      let old_item;
      let old_idx = -1;
      for (let i = 0; i < this.chat_pops.length; i++) {
        let chat = this.chat_pops[i];
        if (chat.parent == char_obj) {
          old_item = chat;
          old_idx = i;
          break;
        }
      }
      if (old_item) {
        //删掉
        old_item.parent.remove(old_item);
      }
      let image = new Image();
      image.src = require("../images/pop.png");
      
    
      function wrapText (context, text, x, y, maxWidth, lineHeight)
      {
      let that = this;
      let ln = "";
      let max_ln = 3;
      let lns = [];
      for (let i = 0; i < text.length; i++) {
        let cr = text[i];
        let ln_old = ln;
        ln = ln + cr;
        var metrics = context.measureText(ln);
        var testWidth = metrics.width;
        if (testWidth > maxWidth) {
          lns.push(ln);
          ln = "";
          if (lns.length == max_ln) {
            break;
          }
        }
      }
      if (ln.length) {
        lns.push(ln);
      }
      y = y - lns.length * 15;
      for (let i = 0; i < lns.length; i++) {
        context.fillText(lns[i], x, y);
        y = y + lineHeight;
      }
    }

      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = 256;
        canvas.height = 512;
        const drawingContext = canvas.getContext("2d");
        drawingContext.fillStyle = "#000000";
        drawingContext.globalAlpha = 0.8;
        drawingContext.drawImage(this, 0, 0);
        drawingContext.globalAlpha = 1;
        drawingContext.fillStyle = "#000000";
        drawingContext.font = "20px Georgia";
        drawingContext.textAlign = "center";
        wrapText(drawingContext, text, 140, 140, 160, 24);
        //drawingContext.fillText("这是一大长串文字，不知道能不能自动换行啥的", 128, 128);

        let map = new THREE.CanvasTexture(canvas);
        let sprite = new THREE.Sprite(
          new THREE.SpriteMaterial({ map: map, color: "#ffffff" })
        );
        sprite.position.set(0, high, 0);
        sprite.scale.set(1000, 2000, 1);
        sprite.depthWrite = false;
        char_obj.add(sprite);
        sprite.beginTime = Date.now();
        sprite.canvas = canvas;
        sprite.alphaTest = 0.01;
        if (old_idx >= 0) {
          that.chat_pops[old_idx] = sprite;
        } else that.chat_pops.push(sprite);
      };
    }
}


export {pop_gif,pop_chat};